import Breadcrumb from '../../core/components/UI/Breadcrumb'
import FormMineralValueChainCreate from '../components/mineral-value-chain-create-page/FormMineralValueChainCreate'
import { useMineralContext } from '../context/mineral/mineralProvider'

export default function MineralValueChainCreatePage() {
  const { mineralState } = useMineralContext()

  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المعادن',
            isActive: false,
            to: '/minerals',
          },
          {
            id: 2,
            label: mineralState.mineral?.name_ar,
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}`,
          },
          {
            id: 3,
            label: 'سلسلة القيمة',
            isActive: false,
          },
          {
            id: 4,
            label: 'اضافة',
            isActive: true,
          },
        ]}
      />
      <div className="border-2 border-muted-500 bg-white p-2">
        <FormMineralValueChainCreate />
      </div>
    </>
  )
}
